import { useEffect, useState } from 'react';
import type { BrowserProvider } from 'ethers';
import { ethers } from 'ethers';
import { useSnackbar } from 'notistack';
import type { SDKProvider } from '@metamask/sdk';

import { WALLET_TYPE } from 'src/constants/wallets';
import { isWalletInstalled } from 'src/utils/extension';

export default function useProvider() {
  const { enqueueSnackbar } = useSnackbar();

  const [provider, setProvider] = useState<BrowserProvider>();
  const [rawProvider, setRawProvider] = useState<SDKProvider>();

  useEffect(() => {
    function connectToMetaMask() {
      try {
        if (typeof window.ethereum !== 'undefined' && isWalletInstalled(WALLET_TYPE.METAMASK)) {
          const ethProvider = new ethers.BrowserProvider(window.ethereum);

          setRawProvider(window.ethereum);
          setProvider(ethProvider);
        }
        // if (currentWallet.walletType === 'Cosmostation' && isWalletInstalled(currentWallet.walletType)) {
        //   const cosmostationProvider = await ethereum();

        //   const ethProvider = new ethers.BrowserProvider(cosmostationProvider);

        //   setRawProvider(cosmostationProvider as unknown as SDKProvider);
        //   setProvider(ethProvider);
        // }
      } catch (error) {
        enqueueSnackbar('Error on connect wallet', {
          variant: 'error',

          autoHideDuration: 3000,
        });
      }
    }

    void connectToMetaMask();
  }, [enqueueSnackbar]);

  return { provider, rawProvider };
}
